import styled from "@emotion/styled";
import {
  APP_TEMA,
  BEI_JYO,
  GREY,
  LIGHT_BLUE,
  RED,
  WHITE,
} from "../../styles/color";

export const RecommendationPageLayout = styled.div`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding-bottom: 100px;
  text-align: center;
`;

export const RecommendationBody = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

export const Title = styled.h2`
  margin: 0 20px 20px;
  color: ${LIGHT_BLUE};
  text-align: left;
`;

export const ToolbarRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 15px;

  @media (max-width: 576px) {
    align-items: stretch;
  }
`;

export const SearchRow = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 15px;

  @media (max-width: 576px) {
    align-items: stretch;
  }
`;

export const SearchInput = styled.input`
  width: min(420px, 100%);
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
`;

export const Card = styled.div`
  background-color: ${WHITE};
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background-color: ${APP_TEMA};
  color: ${WHITE};
  font-size: 16px;
  font-weight: bold;

  @media (max-width: 576px) {
    align-items: flex-start;
    flex-direction: column;
    font-size: 14px;
    padding: 10px 12px;
  }
`;

export const CardBody = styled.div`
  padding: 15px;
  background-color: ${BEI_JYO};
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  background-color: ${BEI_JYO};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${BEI_JYO};
  font-size: 13px;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  th {
    padding: 10px 8px;
    background-color: ${APP_TEMA};
    color: ${WHITE};
    border-bottom: 2px solid ${GREY};
    text-align: left;
    white-space: nowrap;
  }

  td {
    padding: 8px;
    border-bottom: 1px solid ${GREY};
    vertical-align: middle;
  }

  tr:nth-of-type(even) {
    background-color: ${WHITE};
  }

  tr:hover {
    background-color: #e8f4ff;
  }
`;

export const ActionCell = styled.td`
  white-space: nowrap;
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;
`;

export const SmallButton = styled.button`
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background-color: ${(props) =>
    props.variant === "danger"
      ? RED
      : props.variant === "success"
        ? "#28a745"
        : props.variant === "secondary"
          ? "#6c757d"
          : props.variant === "dark"
            ? "#343a40"
            : LIGHT_BLUE};
  color: ${WHITE};
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;

  &:hover {
    opacity: 0.85;
  }

  &:disabled {
    background-color: ${GREY};
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const Muted = styled.span`
  color: ${GREY};
  font-size: 12px;
`;

export const ColorCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
`;

export const ColorSwatch = styled.span`
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 1px solid ${GREY};
  border-radius: 3px;
  vertical-align: middle;
`;

export const EmptyState = styled.div`
  padding: 35px 15px;
  color: ${GREY};
  text-align: center;
`;

export const ErrorText = styled.p`
  margin: 10px 0 0;
  color: ${RED};
  font-size: 13px;
  text-align: left;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
`;

export const ModalContent = styled.div`
  width: 95%;
  max-width: 700px;
  max-height: 92vh;
  overflow-y: auto;
  padding: 20px;
  border-radius: 8px;
  background: ${WHITE};
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 15px;
  color: ${APP_TEMA};
  font-size: 18px;
  font-weight: bold;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const FullWidthField = styled(Field)`
  grid-column: 1 / -1;
`;

export const Label = styled.label`
  margin-bottom: 4px;
  color: #444;
  font-size: 13px;
  font-weight: bold;
`;

export const Required = styled.span`
  margin-left: 4px;
  color: ${RED};
`;

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 8px 9px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }

  &:read-only {
    background-color: #f5f5f5;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  box-sizing: border-box;
  padding: 8px 9px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  resize: vertical;
  font-size: 13px;

  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
`;

export const Hint = styled.span`
  margin-top: 3px;
  color: ${GREY};
  font-size: 11px;
`;

export const ColorInputRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ColorPicker = styled.input`
  width: 42px;
  height: 36px;
  flex: 0 0 42px;
  padding: 2px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  background: ${WHITE};
  cursor: pointer;
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;

  @media (max-width: 576px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;
